import type { IMonitorReplay } from '@interfaces/IMonitorApi';
import { SKELETON_DAY } from './skeletonDay';
import { dayScale } from './trackScale';
import type { IHeldDay } from './useHeldDay';

/**
 * What the bar's track draws: the loaded day (live to input); while the next one
 * loads, the day that was on screen (dimmed) or — with none — a sample day (the
 * skeleton). Held and skeleton tracks are still pictures: inert.
 */
export interface IShownTrack {
  day: IMonitorReplay;
  atMs: number;
  look: 'loaded' | 'held' | 'skeleton';
}

/** The skeleton: a real site day (`SKELETON_DAY`) drawn in grey, its playhead hidden. */
const SKELETON_TRACK: IShownTrack = { day: SKELETON_DAY, atMs: dayScale(SKELETON_DAY).start, look: 'skeleton' };

/** The track for the bar's state; null when there is nothing to draw (not loading, no day). */
export function shownTrack(
  replay: IMonitorReplay | undefined,
  atMs: number,
  held: IHeldDay | null,
  loading: boolean,
): IShownTrack | null {
  if (replay) return { day: replay, atMs, look: 'loaded' };
  if (held) return { day: held.replay, atMs: held.atMs, look: 'held' };
  return loading ? SKELETON_TRACK : null;
}
